import ComposeStyles from './ComposeStyles';
import selectComposeFormatOption from '../actions/selectComposeFormatOption';
import selectShowRecipientWellOption from '../actions/selectShowRecipientWellOption';
import MessageFormatOptionState from '../store/schema/MessageFormatOptionState';
import store from '../store/store';
import { OptionsCheckbox, OptionDescription } from 'owa-options-controls';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react/lib/Dropdown';
import { getFallbackValueIfNull } from 'owa-options-core';
import UserOptionsType from 'owa-service/lib/contract/UserOptionsType';
import { getUserConfiguration } from 'owa-session-store';
import strings from 'owa-strings/owa-options-strings';
import * as React from 'react';
import { reactive } from 'satcheljs/lib/legacy/react';

const styles = require('./MessageFormatFull.scss');

export interface MessageFormatFullProps {
    optionStore?: MessageFormatOptionState;
    userOptions?: UserOptionsType;
}

@reactive({
    optionStore: () => store,
    userOptions: () => getUserConfiguration().UserOptions,
})
export default class MessageFormatFull extends React.Component<MessageFormatFullProps, {}> {
    render() {
        let { optionStore, userOptions } = this.props;

        let showBcc = getFallbackValueIfNull(optionStore.showBcc, userOptions.AlwaysShowBcc);
        let showFrom = getFallbackValueIfNull(optionStore.showFrom, userOptions.AlwaysShowFrom);
        let messageFormat = getFallbackValueIfNull(
            optionStore.composeFormat,
            userOptions.ComposeMarkup
        );

        return (
            <div>
                <div className={styles.showRecipientWellOptions}>
                    <OptionDescription>{strings.options_frombcc_description}</OptionDescription>
                    <OptionsCheckbox
                        checked={showBcc}
                        label={strings.options_format_showBcc}
                        onChange={this.onShowBccChanged}
                    />
                    <OptionsCheckbox
                        checked={showFrom}
                        label={strings.options_format_showFrom}
                        onChange={this.onShowFromChanged}
                    />
                </div>
                <div className={styles.formatDropDownDiv}>
                    <span>{strings.options_format_formatLabel_front}</span>
                    <Dropdown
                        selectedKey={messageFormat}
                        options={[
                            {
                                key: 'Html',
                                text: strings.options_format_dropdown_html,
                            },
                            {
                                key: 'PlainText',
                                text: strings.options_format_dropdown_plaintext,
                            },
                        ]}
                        onChanged={this.onComposeFormatChanged}
                    />
                    <span>{strings.options_format_formatLabel_back}</span>
                </div>
                <ComposeStyles />
            </div>
        );
    }

    private onShowBccChanged(
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) {
        selectShowRecipientWellOption('showBcc', checked);
    }

    private onShowFromChanged(
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) {
        selectShowRecipientWellOption('showFrom', checked);
    }

    private onComposeFormatChanged(option: IDropdownOption, index?: number) {
        selectComposeFormatOption(option.key as string);
    }
}
